import React, { Component } from 'react';
import { Translate } from 'react-localize-redux';
import { func, string } from 'prop-types';
import { connect } from 'react-redux';
import { getIdpOptions, LOGIN_PATH } from '../../../auth';

import styles from '../login.module.css';
import { addErrorMessageAction, setTaskFulfilled, setTaskPending } from '../../../actions';

class MulitSamlLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idpOptions: []
    };

    this.login = this.login.bind(this);
  }

  componentDidMount() {
    this.props.dispatchSetTaskPending();
    getIdpOptions().then((idpOptions) => {
      this.setState({ idpOptions });
    })
      .catch(this.props.dispatchAddErrorMessage)
      .finally(this.props.dispatchSetTaskFulfilled);
  }

  login(event, id) {
    const encodedReferrerURI = encodeURI(this.props.referrer);
    window.location.href = `${LOGIN_PATH}?referrer=${encodedReferrerURI}&idp=${id}`;
  }

  render() {
    return (
      <div className={styles.container}>
        <h1 className={styles.heading}><Translate id="login.chooseOrganization" /></h1>
        <ul>
          {this.state.idpOptions.map((idpOption) => (
            <li className={styles.li} key={idpOption.id}>
              <button
                type="button"
                className={`button ${styles.link}`}
                onClick={(e) => this.login(e, idpOption.id)}
              >
                {idpOption.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

MulitSamlLogin.propTypes = {
  referrer: string.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled())
});

export default connect(null, mapDispatchToProps)(MulitSamlLogin);
